module.exports = __webpack_public_path__ + "static/media/main_page_title.82abdc18.png";